// extracted by mini-css-extract-plugin
export default {"button":"expand-button-module__button--_qVht"};